import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDatabaseChartsDataContext } from './hooks/useDatabaseChartsDataContext';

export const CollectionMethod = () => {
    const { chartData } = useDatabaseChartsDataContext();


    return (
        <SimpleBars
            title={'Forma de Coleta de Informações'}
            horizontal={true}
            subtitles={chartData?.collectionMethod?.map((item) => item.description)}
            values={chartData?.collectionMethod?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
